<template>
    <div>
        <section class="main-slider">
            <!-- softwareInfo.bannerUrl -->
            <div class="page-header-bg" :style="{backgroundImage: softwareInfo.bannerUrl }">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <h1>{{ $t(`software.${softwareInfo.i18n_title}`) }}
					<span style="color: var(--bs-orange);">{{ softwareInfo.title_abb }}</span></h1>
                    <div class="page-header__inner_text">{{ $t(`software.${softwareInfo.i18n_text}`) }}</div>
                    <div class="page-header__inner_action">
                        <a :href="softwareInfo.url" target="_blank" >
                            <div class="page-header__inner_action_item action_item_margin  action_item-color button_hover">
                                <!-- 产品演示  -->
                                {{ $t('software.product_demo') }}
                            </div>
                        </a>
                        <div class="page-header__inner_action_item action_item_margin button_hover" @click="handleSeek()">
                            <a >
                                <!-- 联系我们 -->
                                {{ $t('software.contact_Us') }}
                            </a>
                        </div>
                    </div>
                </div>
                
            </div>
        </section>
      

		<section class="blog-details">
            <div class="container">
                <div class="row" >
					<div class="col-xl-12 col-lg-12" >
                        <!-- <p class="rf_title">{{ softwareInfo.introduceTitle }}</p> -->
                        <p class="rf_text rfc_margin">{{ $t(`software.${softwareInfo.i18n_introduceText}`) }} </p>
                    </div>
                    <div class="col-xl-12 col-lg-12" >
                        <p class="rf_title">{{  $t(`software.${softwareInfo.i18n_solutionTitle}`) }}</p>
                        <p style="text-align: center;">
                            <img class="row_img" :src="softwareInfo.i18n_solutionImg" />
                        </p>
                    </div>
                    <div class="col-xl-12 col-lg-12" >
                        <p class="rf_title">{{  $t(`software.${softwareInfo.i18n_cloudArchitectureTitle}`) }}</p>
                        <p style="text-align: center;">
                            <img class="row_img" :src="softwareInfo.i18n_cloudArchitecture" />
                        </p>
                        <p style="text-align: center;">
                            <img class="row_img" :src="softwareInfo.i18n_weldingFlowChart" />
                        </p>
                       
                    </div>
                    <div class="col-xl-12 col-lg-12" >
                        <p class="rf_text rfc_margin">{{  $t(`software.${softwareInfo.i18n_text1}`)  }} </p>
                        <p class="rf_text rfc_margin">{{  $t(`software.${softwareInfo.i18n_text2}`)  }} </p>
                    </div>
                </div>
			</div> 
         
		</section>
        <seek-dialog v-if="seekShow" :title="softwareInfo.title"  @close="handleClose"/>
    </div>
</template>

<script >

import SeekDialog from "@/components/seekDialog"
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'productSoftware',
    mixins: [MixinsList],
    components: {
        SeekDialog
    },
    data () {
        return {          
            softwareInfo: {},  // 信息
            seekShow: false,
        }
    },
    created() {
        this.getList()  // 获取内容
    },
    mounted () {
         // 确定选中的菜单
        $('.current').removeClass('current');  
        $('.product_li').addClass('current');

        $(".rvt_nub").mouseenter(function(e){

            // // 切换背景
             $('.row_value_list_active').removeClass('row_value_list_active'); 
            var param = 'row_value_img' + $(this).data('text')
            $('.'+param).addClass('row_value_list_active'); 
            // 展示信息
            $('.rvt_nub_action').removeClass('rvt_nub_action');  
            $(this).addClass("rvt_nub_action");
            
             
        
        }).mouseleave(function() {
        })
    },
    methods: {
      
        // 获取内容
        async getList() {
            // const { result } = res
            try {
            const softwareCloud = await loadData('productSoftwareApp', this.lang)
            this.softwareInfo = softwareCloud[this.$route.query.type]
            } catch (error) {
                 console.error('WeldCloud] 加载失败:', error)
                this.softwareInfo = {}
             }
           
        },
          // 联系我们 
          handleSeek() {
            this.seekShow = true
        },
        // 关闭
        handleClose() {
            this.seekShow = false
        }
    }
}
</script>
<style scoped>
.blog-details {
    padding: 60px 0 60px;
}
body {
	color: var(--notech-black) !important;
}
.page-header-bg {
    background-color: transparent; 
}

.page-header__inner h1{
    font-size: var(--font-size-45);
    /* width: 45%; */
    /* text-align: justify; */
    /* text-align-last: justify; */
    text-justify: distribute-all-lines;  /*兼容ie*/
 }

.page-header__inner_text{
    width: 50%;
    font-size: var(--font-size-20);
    margin-top: 13px;
    line-height: 1.75;
    color: var(--notech-white);
 }
 .page-header__inner_action {
    margin-top: 50px;
    display: flex;
 }
 .page-header__inner_action_item {
    cursor: pointer;
    text-align: center;
    color: var(--notech-white);
    border-radius: 5px;
    width: 200px;    
   
    border: 1px solid rgba(169, 183, 222, 0.86);
    padding: 10px 15px;
    background: rgba(255, 255, 255, 0.2);
    position: relative;
    transition: all 0.36s;
    
 }
 .action_item_margin {
    margin: 0 18px;
 }
 .action_item-color {
    /* background: var(--notech-base); */
    background: #3595f7;
 }
 .button_hover:hover {
    /* background: #097cf2 !important; */
    background: var(--notech-base);
}

.row__title {
    margin: 45px 0;
    text-align: center;
    font-size: var(--font-size-30);
    line-height: 50px;
    color: #232e5e;
}
.row__title h3{
    font-size: var(--font-size-30);
    line-height: 50px;
    font-weight: bold;
}
.row_img {
    max-width: 100%;
}
.row_value {
    width: 100%;
    height: 500px;
    visibility: visible;
    animation-name: ysfadeInUp0;
    animation: ysfadeInUp0 .5s ease-in-out 1 both;
    animation-delay: 0.2s;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
}
.row_value_list {
    display: flex;
    width: 100%;
    position: relative;
    display: block;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
}
.row_value_list_item {
    display: none;
    transition: opacity 500ms ease 0s;
}
.row_value_slick-list{
    width: 3426px;
    /* max-height: 500px; */
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    position: relative;
    display: block;
    overflow: hidden;
    margin: 0;
    padding: 0;
}
.row_value_list_img{
    max-width: 100%;
   
}
.row_value_list_active {
    display: block;
}

.row_value_text {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
} 
.rvt_nub{
    width: 33.333333%;
    flex-grow: 1;
    height: 100%;
    border-right: 1px solid rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
}
.rvt_nub_he {
    width: 72%;  
}
.rvt_nub_he_deco{
    margin-bottom: 12px;
    display: block;
    width: 60px;
    height: 60px;
    opacity: 1;
    transition: .1s;
    transform: translateZ(0);
    margin: 0 auto;
}
.rvt_nub_he_deco:before {
    content: "";
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate3d(-50%, -50%, 0) scale(.75);
    transition: .4s;
    border: 1px solid hsla(0, 0%, 100%, .3);
    border-radius: 100%;
    height: 40px;
    width: 40px;
}
.rvt_nub_he_deco i{
    background: hsla(0, 0%, 100%, .8);
    border: 1px solid #fff;
    border-radius: 100%;
    height: 22px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate3d(-50%, -50%, 0) scale(.5);
    transition: .4s;
    width: 22px;
}
.rvt_nub_he_deco:after {
    content: "";
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate3d(-50%, -50%, 0) scale(.75);
    transition: .4s;
    border: 1px solid hsla(0, 0%, 100%, .1);
    border-radius: 100%;
    height: 60px;
    width: 60px;
}

.rvt_nub_title {
    text-align: center;
}
@media screen and (max-width: 1449px) {
.rvt_nub_title  {
    font-size: var(--font-size-24)
}
}
@media screen and (min-width: 1500px) {
.rvt_nub_title  {
    font-size:  var(--font-size-30);
}
}
.rvt_nub_title {
    font-size: var(--font-size-30);
    line-height: 1.5;
    color: #fff;
    font-weight: bold;
}
.rvt_nub_text{
    display: none;
    height: 84px;
    padding-top: 0px;
    margin-top: 15px;
    padding-bottom: 0px;
    margin-bottom: 0px;
}
.rvt_nub_text p {
    font-size: var(--font-size-16);
    line-height: 1.75;
    color: #fff;
    text-align: center;
}
.rvt_nub_action .rvt_nub_text {
    display: block;
    height: 63px;
    padding-top: 0px;
    margin-top: 15px;
    padding-bottom: 0px;
    margin-bottom: 0px;
}
.row_contrast {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    margin-top: 50px;
    padding-bottom: 50px;
    width: 100%;
    /* height: 400px; */
}
.row_contrast_butoon {
    margin-top: 40px;
}
.rct_aglin {
    margin: 0 auto;
}
/* 产品功能-具体介绍 */
.rf_title {
    line-height: 40px;
    margin-top: 10px;
    font-size: var(--font-size-16);
    font-weight: bold;
}
.rfc_margin {
    margin-top: 20px;
}
.rfc_button_margin {
    margin-top: 35px;
}
.rf_text {
    line-height: 30px;
    font-size: var(--font-size-16);
    /* font-weight: bold; */
    white-space: normal;
    text-indent: 32px;
}
</style> 
